import { render, staticRenderFns } from "./TicketCheck.vue?vue&type=template&id=c23a90fc&scoped=true&"
import script from "./TicketCheck.vue?vue&type=script&lang=js&"
export * from "./TicketCheck.vue?vue&type=script&lang=js&"
import style0 from "./TicketCheck.vue?vue&type=style&index=0&id=c23a90fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a90fc",
  null
  
)

export default component.exports